import axios from 'axios'
import config from './config';
import store from '@/store/index.ts'

const token = store.state.token;
if (token) {
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
}

class HttpClient {

// partie login
    verifUserByEmail($email){
        return axios.get(`${config.API_URL}password/verifbymail/${$email}`).then(response => response.data);
    }

    verifDemandeByEmail($email,$token){
        return axios.get(`${config.API_URL}password/verifdemandebymail/?email=${$email}&token=${$token}`).then(response => response.data);
    }

    forgotPassword($email){
        return axios.post(`${config.API_URL}password/forgot/?email=${$email}`).then(response => response.data);
    }

    resetPassword(reinitmdpData){
        return axios.post(`${config.API_URL}password/modifier/`, reinitmdpData).then(response => response.data);
    }

// partie requettes
    getRequetes() {
        return axios.get(`${config.API_URL}requete/getRequetes/`).then(response => response.data);
    }
    getRequetesNotInJeu($idJeuRequetes){
        return axios.get(`${config.API_URL}requete/getRequetesNotIn/${$idJeuRequetes}`).then(response => response.data);
    }

    getRequetesInJeu($idJeuRequetes){
        return axios.get(`${config.API_URL}requete/getRequetesIn/${$idJeuRequetes}`).then(response => response.data);
    }

    searchRequetes($filter){
        return axios.get(`${config.API_URL}requete/searchrequetes/?filter=${$filter}`).then(response => response.data);
    }

    searchRequetesByKeyword($filter){
        return axios.get(`${config.API_URL}requete/searchrequetesByKeyword/?filter=${$filter}`).then(response => response.data);
    }

    loadRequete($idRequete) {
        return axios.get(`${config.API_URL}requete/afficher/${$idRequete}`).then(response => response.data);
        }
    insertRequete(requeteData){
        return axios.post(`${config.API_URL}requete/inserer/`, requeteData).then(response => response.data);
    }
    testerRequete(saisieData){
        return axios.post(`${config.API_URL}requete/tester/`,saisieData).then(response => response.data);
    }

    updateRequete(requeteData) {
        return axios.post(`${config.API_URL}requete/modifier/`, requeteData).then(response => response.data);        
    }
    deleteRequete($idRequete) {
        return axios.post(`${config.API_URL}requete/supprimer/${$idRequete}`).then(response => response.data);       
    }
    verifBeforeDelete($idRequete){
        return axios.get(`${config.API_URL}requete/verif/${$idRequete}`).then(response => response.data);
    }
    
// partie jeu de requettes
    getJeux(){
        return axios.get(`${config.API_URL}jeuRequetes/getJeuRequetesLite/`).then(response => response.data);
    }
    loadJeuRequete($idJeuRequetes) {
        return axios.get(`${config.API_URL}jeuRequetes/afficher/${$idJeuRequetes}`).then(response => response.data);
        }
    insertJeuRequete(jeuRequeteData){
        return axios.post(`${config.API_URL}jeuRequetes/inserer/`, jeuRequeteData).then(response => response.data);
    }
    updateJeuRequete(jeuRequeteData) {
        return axios.post(`${config.API_URL}jeuRequetes/modifier/`, jeuRequeteData).then(response => response.data);
    }
    deleteJeuRequete($idJeuRequetes) {
        return axios.post(`${config.API_URL}jeuRequetes/supprimer/${$idJeuRequetes}`).then(response => response.data);       
    }
    insertRequetesFromJeu(lRequeteJeuRequetesData) {
        return axios.post(`${config.API_URL}lRequeteJeuRequetes/inserer/`, lRequeteJeuRequetesData).then(response => response.data);
    }
    deleteRequeteFromJeu($idJeuRequetes,$idRequete) {
        return axios.post(`${config.API_URL}lRequeteJeuRequetes/supprimer/?idJeuRequetes=${$idJeuRequetes}&idRequete=${$idRequete}`).then(response => response.data);
    }

// partie schema
    getSchema() {
        return axios.get(`${config.API_URL}schema/getSchemas/`).then(response => response.data);
    }

// partie parametre
    getParametresFromJeu($idJeuRequetes){
        return axios.get(`${config.API_URL}parametre/getParamsFromJeu/${$idJeuRequetes}`).then(response => response.data);
    }

// partie lancement
    lancerJeu(lancementData){
        return axios.post(`${config.API_URL}lancement/lancer/`, lancementData).then(response => response.data);
    }

// partie rapport
    getExecutions(){
        return axios.get(`${config.API_URL}execution/getAll/`).then(response => response.data);
    }

    getRapport(idExecution){
        return axios.get(`${config.API_URL}rapport/afficher/${idExecution}`).then(response => response.data);
    }

    getRequetesFromExecution(idExecution){
        return axios.get(`${config.API_URL}rapport/requetes/${idExecution}`).then(response => response.data);
    }

    getFichier(idExecution){
        return axios.get(`${config.API_URL}execution/csv/${idExecution}`).then(response => response.data);
    }

    getAnomalies(idExecution){
        return axios.get(`${config.API_URL}rapport/ligneAno/${idExecution}`).then(response => response.data);
    }

    getAnomaliesToJustif($idExecution,$idRequete){
        return axios.get(`${config.API_URL}rapport/AnomalieToJustif/?idExecution=${$idExecution}&idRequete=${$idRequete}`).then(response => response.data);
    }

    searchRapports($filter){
        return axios.get(`${config.API_URL}execution/searchExecutions/?filter=${$filter}`).then(response => response.data);
    }

    searchRapportsByJeu($filter){
        return axios.get(`${config.API_URL}execution/searchExecutionsByJeu/?filter=${$filter}`).then(response => response.data);
    }

    searchRapportsByAuteur($filter){
        return axios.get(`${config.API_URL}execution/searchExecutionsByAuteur/?filter=${$filter}`).then(response => response.data);
    }

    validJustif($validJustif,$commentaire,$idLigneAnomalie) {
        return axios.post(`${config.API_URL}justification/valider/?valid=${$validJustif}&commentaire=${$commentaire}&idLigneAnomalie=${$idLigneAnomalie}`).then(response => response.data);
    }

    insertJustification(justificationData){
        return axios.post(`${config.API_URL}justification/inserer/`, justificationData).then(response => response.data);
    }

    loadJustification($idAnomalie) {
        return axios.get(`${config.API_URL}justification/byligne/${$idAnomalie}`).then(response => response.data);
    }

    deleteJustification($idJustification) {
        return axios.post(`${config.API_URL}justification/supprimer/${$idJustification}`).then(response => response.data);
    }

    updateJustification(justificationData){
        return axios.post(`${config.API_URL}justification/modifier/`, justificationData).then(response => response.data);
    }

    // partie rapport sans connexion
    searchAnomalieByRapportAndIdAnomalie($idExecution, $filter){
        return axios.get(`${config.API_URL}ligneAnomalieLancement/getligneAnobyidexeAndIdLigne/?idExecution=${$idExecution}&filter=${$filter}`).then(response => response.data);
    }
    getBddByIdJeuRequetes($idJeuRequetes){
        return axios.get(`${config.API_URL}bdd/byjeu/?idJeuRequetes=${$idJeuRequetes}`).then(response => response.data);        
    }
    getRapportByCode(code){
        return axios.get(`${config.API_URL}verification/afficherRapportByCode/${code}`).then(response => response.data);
    }
    getAnomaliesToJustifByIdLigne($idExecution,$idAnomalie){
        return axios.get(`${config.API_URL}rapport/AnomalieToJustifByIdLigne/?idExecution=${$idExecution}&idAnomalie=${$idAnomalie}`).then(response => response.data);
    }
    getAnomaliesToJustifOffline($idExecution,$idRequete){
        return axios.get(`${config.API_URL}verification/AnomalieToJustif/?idExecution=${$idExecution}&idRequete=${$idRequete}`).then(response => response.data);
    }
    getRequetesFromExecutionOffline(idExecution){
        return axios.get(`${config.API_URL}verification/requetes/${idExecution}`).then(response => response.data);
    }
    loadJustificationOffline($idAnomalie) {
        return axios.get(`${config.API_URL}verification/justificationbyligne/${$idAnomalie}`).then(response => response.data);
    }
    insertJustificationOffline(justificationData){
        return axios.post(`${config.API_URL}verification/insererjustification/`, justificationData).then(response => response.data);
    }
    deleteJustificationOffline($idJustification) {
        return axios.post(`${config.API_URL}verification/supprimerjustification/${$idJustification}`).then(response => response.data);
    }
    updateJustificationOffline(justificationData){
        return axios.post(`${config.API_URL}verification/modifierjustification/`, justificationData).then(response => response.data);
    }
}
    
export default new HttpClient() 
